import { fetchOk } from '@atlassian/mpac-fetch-wrapper';
import queryString from 'query-string';
import { getPartnerApisHeaders } from './partnerApisHeaders';
export const cloudConversionsAPIPathBuilder = (partnerId, queryParams) => "/rest/2/vendors/".concat(partnerId, "/reporting/sales/metrics/conversion?").concat(queryString.stringify(queryParams));

/* Get Cloud Conversions for a given Partner */
export const getCloudConversions = (mpacBaseUrl, partnerId, queryParams) => {
  const apiPath = cloudConversionsAPIPathBuilder(partnerId, queryParams);
  return fetchOk("".concat(mpacBaseUrl).concat(apiPath), {
    headers: getPartnerApisHeaders()
  }).then(response => response.json());
};
const routeToApiMapping = {
  churn: 'churn',
  renewals: 'renewal'
};
export const cloudReportAPIPathBuilder = (partnerId, reportName, queryParams) => "/rest/2/vendors/".concat(partnerId, "/reporting/sales/metrics/").concat(routeToApiMapping[reportName], "?").concat(queryString.stringify(queryParams));

/* Get Cloud Churn or Renewal for a given Partner based on Report Name passed */
export const getCloudReport = (mpacBaseUrl, partnerId, reportName, queryParams) => {
  const apiPath = cloudReportAPIPathBuilder(partnerId, reportName, queryParams);
  return fetchOk("".concat(mpacBaseUrl).concat(apiPath), {
    headers: getPartnerApisHeaders()
  }).then(response => response.json());
};

/* Get Cloud Churn Benchmark for a given Partner */
export const getChurnBenchmark = (mpacBaseUrl, partnerId, queryParams) => fetchOk("".concat(mpacBaseUrl, "/rest/2/vendors/").concat(partnerId, "/reporting/sales/metrics/churn/benchmark?").concat(queryString.stringify(queryParams)), {
  headers: getPartnerApisHeaders()
}).then(response => response.json());